import { render, staticRenderFns } from "./ElectronicRecordConfirm.vue?vue&type=template&id=3d22a287&scoped=true&"
import script from "./ElectronicRecordConfirm.vue?vue&type=script&lang=ts&"
export * from "./ElectronicRecordConfirm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d22a287",
  null
  
)

export default component.exports